export const isStripePaymentRequired = (): boolean => {
  return false // AIQ Will only use order-based payments. import.meta.env.VITE_STRIPE_PAYMENT_REQUIRED !== 'false';
};

export const isEnhancementEnabled = (): boolean => {
  return true;
};